import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import { CollectionPageContributorsProps } from '../../types/pages/c/username';

import Layout from '../../layout/Layout';
import CollectionPageContributors from '../../components/collections/CollectionPageContributors';

import contributorsHelpers from '../../helpers/contributorsHelpers';

const ProductPageContributor: React.FC = (props: CollectionPageContributorsProps) => {
  return (
    <Layout>
      <CollectionPageContributors {...props} />
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx: GetServerSidePropsContext) => {
  const { fetchContributorPageServersideProps } = contributorsHelpers;
  return await fetchContributorPageServersideProps(ctx);
};

export default ProductPageContributor;
